"use client";
import { createContext, useContext } from "react";

const CAPTCHA_REQUIRED_UNTIL_LOADED: CaptchaConfig = {
  isLoginCaptchaRequired: true,
  isRegistrationCaptchaRequired: true,
};

const CaptchaConfigContext = createContext<CaptchaConfig>(
  CAPTCHA_REQUIRED_UNTIL_LOADED,
);

export const useCaptchaConfig = () => useContext(CaptchaConfigContext);

// Server Components can't render `Context.Provider` from a client module.
export const CaptchaConfigContextProvider: FC<{
  value: CaptchaConfig;
}> = ({ value, children }) => (
  <CaptchaConfigContext.Provider value={value}>
    {children}
  </CaptchaConfigContext.Provider>
);
